/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for the scheduled-changes tick (generation + go-live).
 */
export interface ScheduledChangesTickParams {
  [key: string]: unknown;
}
